/*
* @描述: 编辑商机
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/24 15:06
*/
<template>
    <van-popup v-model="dialogVisible"
               :style="{ width: '100%',height: '100%' }">
        <div v-loading="loading" class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              title="返回"
                              @returnEvent="handleDialogClose"></ReturnNavBar>
            </div>
            <div class="detail_wrap_container padding_10">
                <CustomFormMobile v-if="dataLoaded&&formInfoList.length"
                                  ref="projectForm"
                                  :field_list="formInfoList"
                                  :form_detail="projectFormData"
                                  :is_release="projectFormData.is_release"
                                  :field_form="'projects'"
                                  :pk_id="project_id"
                                  @submit-form="submitProjectFormData"/>
                <div v-if="isApproval===1" class="add_approval_select_process">
                    <div class="m_page_little_title">
                        <span class="title">审批流程</span>
                    </div>
                    <div class="detail_chunk_wrap">
                        <approveProcessSelect ref="approveProcessSelectRef"
                                              :approval_node_list="approval_node_list">
                        </approveProcessSelect>
                    </div>
                </div>
            </div>
            <div class="add_footer_wrap">
                <van-button :disabled="btnDisabled"
                            plain
                            type="info"
                            @click="handleDialogSave">保存
                </van-button>
                <van-button :disabled="btnDisabled"
                            size="large"
                            type="primary"
                            @click="handleDialogConfirm">提交
                </van-button>
            </div>
        </div>
    </van-popup>
</template>
<script>
import {
    getFormFields,
    projectAdd,
    getApprovalNodes, projectDetail, projectEdit,
} from "@/api";
import {getBusinessIsApproval} from "@/utils";
import {pagination} from "@/mixins";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile.vue";

export default {
    name: "BusinessAdd",
    data() {
        return {
            loading: false,
            formInfoList: [],
            projectFormData: {},
            projectStageId: 0,
            isApproval: 0,
            is_release: 1,
            approval_node_list: [],
            btnDisabled: false,
            dataLoaded: false,
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        field_auth: {
            type: [Array, Object],
            default: () => []
        },
        project_id: {
            type: Number,
            default: 0,
        },
    },
    components: {CustomFormMobile, ReturnNavBar, PersonnelCard, approveProcessSelect},
    created() {
        this._getFromFields()
    },
    methods: {
        _getFromFields() {
            this.loading = true
            getFormFields({
                field_form: 'projects'
            }).then(res => {
                if (res.code === 200) {
                    this.formInfoList = res.data
                    getBusinessIsApproval('project_add').then(res => {
                        this.isApproval = res
                        if (this.isApproval === 1) {
                            getApprovalNodes({
                                approval_type: 'project_add',
                            }).then(res => {
                                if (res.code === 200) {
                                    this.approval_node_list = res.data
                                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                                }
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        }
                    })
                    this.getBusinessDetail()
                } else {
                    this.loading = false
                }
            }).catch(() => {
                this.loading = false
            })
        },

        //获取商机详情
        getBusinessDetail() {
            this.loading = true
            projectDetail({
                project_id: this.project_id
            }).then(res => {
                if (res.code === 200) {
                    this.projectFormData = res.data
                    this.is_release = res.data.is_release
                    this.dataLoaded = true
                }
                this.loading = false
            })
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        //获取商机表单数据
        submitProjectFormData(data) {
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            this.projectFormData = {
                ...data,
                is_release: this.is_release,
                project_id: this.project_id,
                node_list: this.approval_node_list
            }
            projectEdit(this.projectFormData).then(res => {
                if (res.code === 200) {
                    this.$toast.success('编辑成功')
                    this.$emit('update:dialogVisible', false)
                    this.$emit('refresh-list')
                }
            })
        },

        //获取商机阶段表单数据
        submitProjectStageFormData(data) {
            if (this.isApproval === 1 && !this.$refs.approveProcessSelectRef.handleClickPublish()) return false
            this.projectFormData = {
                ...this.projectFormData,
                is_release: this.is_release,
                ...data,
                project_id: this.project_id,
                node_list: this.approval_node_list
            }
            projectEdit(this.projectFormData).then(res => {
                if (res.code === 200) {
                    this.$toast.success('编辑成功')
                    this.$emit('update:dialogVisible', false)
                    this.$emit('refresh-list')
                }
            })
        },

        handleDialogSave() {
            this.is_release = 0
            this.$refs.projectForm.handleClickPublish(false)
        },

        // 确定
        handleDialogConfirm() {
            this.is_release = 1
            this.$refs.projectForm.handleClickPublish()
        },
    },
}
</script>
<style lang="scss" scoped>

</style>